/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { DocumentApi } from '../sdk/services';
import { MatDialog } from '@angular/material/dialog';
import { SpinnerComponent } from '../components/spinner/spinner.component';
import { saveAs } from 'file-saver/FileSaver';

export class MediaHandler {
  constructor (
    private DocumentApi: DocumentApi,
    private dialog: MatDialog,
  ) {};


  /**
   * Get the size of the file for display purposes
   * @param {number} bytes    Bytes to format
   * @param {number} decimals Decimal places for file size
   */
  public formatBytes(bytes: number, decimals: number) {
    if (bytes == 0) return '0 Bytes';
    var k = 1024,
      dm = decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  /**
   * Convert base64 string to a blob
   * @param {string} base64Data  Base64 data to convert
   * @param {any}    contentType The type of content, can be null for blank
   * @return {Blob} Blob of the data
   */
  public base64toBlob(base64Data: string, contentType: any) {
    contentType = contentType || '';
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  }


  /**
   * Download the file with ID
   * @param {string} id   ID of the stored file
   * @param {string} name Currently unusued
   */
  public download(id: string, name: string) {
    // Probably better to change to a API side download  as this provides
    // no real progress (We could add a spinner)

    this.DocumentApi.findById(id).toPromise().then((response: any) => {
      var filename = response.metadata.name;
      const blob = new Blob([this.base64toBlob(response.file, '')], { type: response.metadata.type });
      saveAs(blob, filename);
    });
  }

  /**
   * Download the file with ID, show a dialog with spinner whilst downloading
   * @param {string} id   ID of the stored file
   * @param {string} name Currently unusued
   */
  public downloadWithDialog(id: string, name: string) {
    // Probably better to change to a API side download  as this provides
    // no real progress (We could add a spinner)

    const dialog = this.dialog.open(SpinnerComponent, {
      height: '120px',
      width: '250px',
      data: {
        title: 'File Downloading'
      }
    });

    this.DocumentApi.findById(id).toPromise().then((response: any) => {
      var filename = response.metadata.name;
      const blob = new Blob([this.base64toBlob(response.file, '')], { type: response.metadata.type });
      saveAs(blob, filename);
      this.dialog.closeAll();
    });
  }

  /**
   * Get the profile picture for a speicifed user
   * @param {string}  userId    ID of the user
   * @param {boolean} thumbnail If true the thumbnail version of the image will be returned
   * @return {} The requested image
   */
  public getUserProfilePicture(userId: string, thumbnail:boolean) {
    thumbnail = thumbnail || false;
  }

  /**
   * Returns the thumbnail of the specified media
   * @param {string} id The ID of the media
   * @return {} The thumbnail of the media
   */
  public getThumbnail(id:string) {

  }

}
